module.exports = __webpack_public_path__ + "static/media/instapay_icon_2.0e2b5bec.png";